import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";

import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';
import { TryCatchStmt } from '@angular/compiler';

import { UtilesService } from './utiles.service';
import { Usuario } from '../Models/Usuario';

import { Resultado } from '../Models/Resultado';


@Injectable()
export class UsuarioService {


  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }


  /**
   * Se obtiene todos los usuarios de la compañia ccon el estado activo
   * @param compania Codigo de la compañia
   */
  ObtenerUsuarios(compania: string): Observable<Usuario[]> {

    try {

      let url = this._utiles.getURL("usuario/" + compania);

      return this._http.get(url).map((response: Response) => {
        return <Usuario[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }


  /**
   * Se obtiene el usuario solicitado 
   * @param compania Codigo de la compañia
   * @param idUsuario Codigo del usuario
   */
  ObtenerUsuario(compania: string, idUsuario): Observable<Usuario> {

    try {

      let url = this._utiles.getURL("usuario/" + compania + "/" + idUsuario);

      return this._http.get(url).map((response: Response) => {
        return <Usuario>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }

  /**
   * Se guarda el registro de usuario
   * @param usuario Objeto de tipo "Usuario"
   */
  public GuardarRegistro(usuario: Usuario) {

    try {

      let params = JSON.stringify(usuario);

      let url = this._utiles.getURL("usuario/");

      let headers = new Headers({ 'Content-Type': 'application/json' });


      let data: any;

      return this._http.post(url, usuario, { headers: headers }).map(res => res.json());

    } catch (error) {
      console.log(error);
    }


  }


  /**
   * Valida la informacion dada en el login y devuelve el resultado debido
   * @param usuario Objeto de tipo "Usuario"
   */
  public ValidarAcceso(usuario: Usuario): Observable<Resultado> {

    try {

      let params = JSON.stringify(usuario);

      let url = this._utiles.getURL("usuario/validarlogin/");

      let headers = new Headers({ 'Content-Type': 'application/json' });


      let data: any;


      return this._http.post(url, usuario, { headers: headers }).map(res => res.json());

    } catch (error) {
      console.log(error);
    }


  }




  /**
   * Se obtiene todos los usuarios de la compañia, para ser mostrados en un combo box
   * @param compania Objeto de tipo "Usuario"
   */
  ObtenerUsuariosComboBox(compania: string): Observable<Usuario[]> {

    try {

      let url = this._utiles.getURL("usuario/usuariocombobox/" + compania);


      return this._http.get(url).map((response: Response) => {
        return <Usuario[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }


}
